'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://www.kirupa.com/react/transferring_properties.htm
// http://stackoverflow.com/questions/36631761/when-should-i-add-redux-to-a-react-app
var Module1Extra1 = (_dec = (0, _reactRedux.connect)(function (state) {
  return { user: state.auth.user };
}), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Module1Extra1, _Component);

  function Module1Extra1() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Module1Extra1);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Module1Extra1.__proto__ || (0, _getPrototypeOf2.default)(Module1Extra1)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      title: 'Statistics'
    }, _this.handleChange = function (str, event) {
      var obj = _this.state;
      obj[str] = event.target.value;
      _this.setState(obj);
    }, _this.handleComplete = function () {
      var obj = {};
      obj.isCompleted = true;
      _this.setState(obj);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  /*
   * User types in something for what was
   * involved in the diet
   */


  /*
   * Handle when user finishes this module
   */


  (0, _createClass3.default)(Module1Extra1, [{
    key: 'render',
    value: function render() {
      var styles = require('../../Modules.scss');
      var graphImg = require('../Assets/graph.png');
      var graphImg2 = require('../Assets/graph2.png');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: styles.activityPanel },
          _react2.default.createElement(
            'div',
            { className: styles.title },
            _react2.default.createElement(
              'h3',
              null,
              'Module 1'
            ),
            _react2.default.createElement(
              'h2',
              null,
              this.state.title
            )
          ),
          _react2.default.createElement(
            ReactBootstrap.Row,
            null,
            _react2.default.createElement(
              ReactBootstrap.Col,
              { md: 12 },
              _react2.default.createElement(
                ReactBootstrap.Col,
                { md: 7 },
                _react2.default.createElement(ReactBootstrap.Image, { src: graphImg, responsive: true }),
                _react2.default.createElement('div', { className: styles.spacer40 })
              ),
              _react2.default.createElement(
                ReactBootstrap.Col,
                { md: 5 },
                _react2.default.createElement(
                  'h3',
                  null,
                  'Eating habits after cancer treatment survey'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'We asked 50 parents about their children\u2019s eating habits before, during and after treatment. This graph shows their responses.'
                ),
                _react2.default.createElement(
                  'h3',
                  null,
                  'Children\u2019s eating habits before, during and after cancer treatment'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'Before treatment, most parents reported that their child ate some vegies (teal bar).'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'During treatment, no parents reported that their child ate vegies (dark green bar).'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'After treatment had finished, only six parents reported that their child ate vegies again.'
                ),
                _react2.default.createElement('br', null),
                _react2.default.createElement(
                  'p',
                  null,
                  'Another important finding was that children ate a lot more \u2018junk food\u2019 (e.g. sweet and savoury snacks) during treatment and after treatment had finished.'
                )
              ),
              _react2.default.createElement(
                ReactBootstrap.Col,
                { md: 7 },
                _react2.default.createElement(ReactBootstrap.Image, { src: graphImg2, responsive: true }),
                _react2.default.createElement('div', { className: styles.spacer40 })
              ),
              _react2.default.createElement(
                ReactBootstrap.Col,
                { md: 5 },
                _react2.default.createElement(
                  'h3',
                  null,
                  'Children\u2019s vegetable intake after cancer treatment'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'The following graph shows how many serves of vegies children ate after they had finished treatment.'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'Their parents reported these facts.'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'The orange bar is the amount of vegies (serves) children ate.'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'The green bar is the recommended amount of vegies (serves of vegies) children should be eating.'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'These recommendations come from the Australian Dietary Guidelines (ADG).'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'In the graph, you can see that the orange bars are lower than the green bars for every age group.'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'These numbers show us that most children do not eat enough vegies after they finished cancer treatment.'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'This is why Reboot Kids is targeting children\u2019s vegetable intake.'
                )
              )
            )
          )
        )
      );
    }
  }]);
  return Module1Extra1;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object
}, _temp2)) || _class);
exports.default = Module1Extra1;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/0/Extra/Extra1.js
// module id = 1158
// module chunks = 0